const publicRoutePaths = {
    REGISTRATION: {
        path: "/registration",
        restricted: true,
        isAuthPage: true,
        page_module: ['HOME']
    },
    REGISTRATION_V2: {
        path: "/registration/v2",
        restricted: true,
        isAuthPage: true,
        page_module: ['HOME']
    },
    LOGIN: {
        path: "/login",
        restricted: true,
        isAuthPage: true,
        page_module: ['HOME']
    },
    FORGOT_PSWD: {
        path: "/forgot-password",
        restricted: true,
        isAuthPage: true,
        page_module: ['HOME']
    },
    RESET_PSWD: {
        path: "/reset-password",
        restricted: true,
        isAuthPage: true,
        page_module: ['HOME']
    },
    TERMS: {
        path: "/terms-and-conditions",
        restricted: false,
        page_module: ['HOME']
    },
    SUPPLIER_TERMS: {
        path: "/terms-and-conditions-supplier",
        restricted: false,
        page_module: ['HOME']
    },
    BUYER_TERMS: {
        path: "/terms-and-conditions-buyer",
        restricted: false,
        page_module: ['HOME']
    },
    LOGISTIC_TERMS: {
        path: "/terms-and-conditions-logistic",
        restricted: false,
        page_module: ['HOME']
    },
    BUYER_SUPPLIER_TERMS: {
        path: "/terms-and-conditions-buyer-supplier",
        restricted: false,
        page_module: ['HOME']
    },
    HOME: {
        path: "/",
        restricted: false,
        page_module: ['HOME']
    },
    ABOUT_US: {
        path: "/about",
        restricted: false,
        page_module: ['HOME']
    },
    OUR_SERVICES: {
        path: "/our-services",
        restricted: false,
        page_module: ['HOME']
    },
    GLOBAL_TRADE_NETWORK: {
        path: "/benefits/global-business-network",
        restricted: false,
        page_module: ['HOME']
    },
    DIGITAL_PROMOTION: {
        path: "/benefits/digital-promotion",
        restricted: false,
        page_module: ['HOME']
    },
    FINANCIAL_PROTECTION: {
        path: "/benefits/financial-protection",
        restricted: false,
        page_module: ['HOME']
    },
    CUSTOMER_SUPPORT: {
        path: "/benefits/customer-support",
        restricted: false,
        page_module: ['HOME']
    },
    BUSINESS_LEADS: {
        path: "/benefits/quality-business-leads",
        restricted: false,
        page_module: ['HOME']
    },
    EVENT_HIGHLIGHTS: {
        path: "/event-highlights",
        restricted: false,
        page_module: ['HOME']
    },
    SUPPLIER_INQUIRY: {
        path: "/supplier-inquiry",
        restricted: false,
        isAuthPage: true,
        page_module: ['HOME']
    },
    LOGISTIC_INQUIRY: {
        path: "/logistics-partner-inquiry",
        restricted: false,
        isAuthPage: true,
        page_module: ['HOME']
    },
    CONTACT_US: {
        path: "/contact-us",
        restricted: false,
        page_module: ['HOME']
    },
    SEARCH_LOGISTIC_PARTNER: {
        path: "/search-partner",
        restricted: false,
        page_module: ['HOME']
    },
    LANDING_PAGE: {
        path: "/landing/:id",
        restricted: false,
        page_module: ['HOME', 'PRODUCT']
    },
    LANDING_PAGE_NOT_FOUND: {
        path: "/landing/page-not-found",
        restricted: false,
        page_module: ['HOME', 'PRODUCT']
    },
    COMPANY_PAGE_NOT_FOUND: {
        path: "/company-catalogue/page-not-found",
        restricted: false,
        page_module: ['HOME', 'PRODUCT']
    },
    BECOME_SUPPLIER: {
        path: "/become-supplier",
        restricted: false,
        page_module: ['HOME']
    },
    JOIN_LOGISTIC: {
        path: "/join-logistic",
        restricted: false,
        page_module: ['HOME']
    },
    SEARCH_DETAIL: {
        path: "/search-detail",
        restricted: false,
        page_module: ['HOME']
    },
    VIEW_ALL_INQUIRIES: {
        path: "/view-all-inquiries",
        restricted: false,
        page_module: ['HOME']
    },
    OUR_PRODUCTS: {
        path: "/our-products",
        restricted: false,
        page_module: ['HOME']
    },
    PRIVACY_POLICY: {
        path: "/privacy-policy",
        restricted: false,
        page_module: ['HOME']
    },
    BLOG_LIST: {
        path: "/blogs",
        restricted: false,
        page_module: ['HOME']
    },
    BLOG_DETAIL: {
        path: "/blog/:blog_title",
        restricted: false,
        page_module: ['HOME']
    },
    MARKET_PLACE: {
        path: "/market-place",
        restricted: false,
        page_module: ['PRODUCT']
    },
    PRODUCT_CATALOGUE: {
        path: "/product-catalogue/:slug",
        restricted: false,
        page_module: ['PRODUCT']
    },
    MARKET_DETAIL: {
        path: "/market-detail",
        restricted: false,
        page_module: ['PRODUCT']
    },
    COMPANY_CATALOGUE: {
        path: "/company-catalogue/:id",
        restricted: false,
        page_module: ['HOME', 'PRODUCT']
    },
    OUR_PARTNERS_DETAIL: {
        path: "/our-partners",
        restricted: false,
        page_module: ['HOME']
    },
    SEARCH_SUPPLIERS: {
        path: "/search-suppliers",
        restricted: false,
        page_module: ['PRODUCT']
    }

    /** Not in used currently 2025-29-02 */
    /* PARTNER_PAGE: {
        path: "/partner/:id",
        element: <LandingPage masking={true} />
    }*/
};

export {
    publicRoutePaths
};
